import { AiLoader } from '@/components/ats';

export const AISpinner = () => {
  return (
    <AiLoader
      defaultDuration={3}
      containerProps={{
        maxW: '100%',
      }}
      config={{
        steps: [
          {
            id: '1',
            label: 'Reviewing interview information...',
            duration: 1,
          },
          {
            id: '2',
            label: 'Identifying key matching queries for the original search',
          },
          { id: '3', label: 'Splitting the queries into multiple searches' },
          { id: '4', label: 'Surfacing contextual data to the searches' },
          { id: '5', label: 'Packaging up the results' },
        ],
        message: {
          title: 'AI is thinking...',
          description:
            'Our AI is analyzing the search query and running multiple parallel searches for you',
        },
      }}
    />
  );
};
